/** This query is used to resolve the plan references and their associated prices for the pricing page.
 Mainly used to generate per-plan structured data */
export const queryPricingResolved = groq`*[
  _type == "pricing" && currentPathname == $currentPathname
][0].plans {
  ...,
  plans[] {
    ...,
    "resolvedPlan": selectPlan.reference->,
    "resolvedPlanPrices": selectPlan.reference->price.reference->variations[] {
      "name": personalizationVariant,
      "value": sectionBuilder.sectionBuilder[_type == "sectionBuilderPortableText"][0].sectionBuilderPortableText[0].children[0].text
    }
  }
}`;
